module.exports = __webpack_public_path__ + "media/images/app/visitors/bridal/diamond_earrings-5c9f32f9c3e9de4e9bfa2d6e07dc45fb.webp";